"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M6 5a1 1 0 00-1-1H4a1 1 0 00-1 1v1a1 1 0 001 1h1a1 1 0 001-1V5zM21 5a1 1 0 00-1-1H9a1 1 0 00-1 1v1a1 1 0 001 1h11a1 1 0 001-1V5zM3 11.5a1 1 0 011-1h1a1 1 0 011 1v1a1 1 0 01-1 1H4a1 1 0 01-1-1v-1zM21 11.5a1 1 0 00-1-1H9a1 1 0 00-1 1v1a1 1 0 001 1h11a1 1 0 001-1v-1zM3 18a1 1 0 011-1h1a1 1 0 011 1v1a1 1 0 01-1 1H4a1 1 0 01-1-1v-1zM21 18a1 1 0 00-1-1H9a1 1 0 00-1 1v1a1 1 0 001 1h11a1 1 0 001-1v-1z" }), "List");
//# sourceMappingURL=List.js.map